import { useState } from "react";
import { createShapeId } from "@tldraw/tlschema";
import type { BoardTable } from "../shared/schema";
import { sheetAt } from "./sheet-operations";
import type { WorkspaceModel } from "./useWorkspace";

export function TableCreation({
  model,
  close,
}: {
  model: WorkspaceModel;
  close: () => void;
}) {
  const [rows, setRows] = useState(4);
  const [columns, setColumns] = useState(3);
  return (
    <form
      className="table-creation"
      onSubmit={(event) => {
        event.preventDefault();
        const { editor } = model;
        if (
          !model.canEdit ||
          editor.getIsReadonly() ||
          !Number.isInteger(rows) ||
          !Number.isInteger(columns) ||
          rows < 1 ||
          rows > 30 ||
          columns < 1 ||
          columns > 12
        )
          return;
        const center = editor.getViewportPageBounds().center;
        const parent = sheetAt(editor, center);
        const point = parent
          ? editor.getPointInShapeSpace(parent, center)
          : center;
        const id = createShapeId();
        const w = Math.max(320, columns * 120),
          h = 44 + rows * 43;
        editor.markHistoryStoppingPoint("Create table");
        editor.createShape<BoardTable>({
          id,
          type: "table",
          parentId: parent?.id ?? editor.getCurrentPageId(),
          x: point.x - w / 2,
          y: point.y - h / 2,
          opacity: 1,
          meta: {
            autoFitRows: true,
            columnWidths: Array(columns).fill(w / columns),
          },
          props: {
            name: "Table",
            source: "",
            rows: Array.from({ length: rows }, () =>
              Array.from({ length: columns }, () => ""),
            ),
            headers: false,
            layout: "table",
            w,
            h,
          },
        });
        model.choose("select");
        editor.select(id);
        close();
      }}
    >
      <p>A blank, editable table on your board.</p>
      <label>
        Rows
        <input
          type="number"
          autoFocus
          min={1}
          max={30}
          required
          value={rows}
          onChange={(event) => setRows(Number(event.target.value))}
        />
      </label>
      <label>
        Columns
        <input
          type="number"
          min={1}
          max={12}
          required
          value={columns}
          onChange={(event) => setColumns(Number(event.target.value))}
        />
      </label>
      <button type="submit" className="primary">
        Add table
      </button>
    </form>
  );
}
